import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { GridApi, GridOptions } from 'ag-grid-community';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient, HttpEventType, HttpResponse } from '@angular/common/http';
import { checkMimeTypcv } from './mimetype';
import { LookupService } from '../services/lookup.service';
import { QuillEditorComponent } from 'ngx-quill';
import { BusinessEntityService } from '../services/business-entity.service';
import { Router } from '@angular/router';
import { AssumedRoleStoreService } from '../services/assumed-role-store.service';
import { formatDate } from '@angular/common';
import { AgGridSortingService } from '../services/ag-grid-sorting.service';


interface FileData {
  name: string;
  isSelected: boolean;
}

@Component({
  selector: 'app-emailer',
  templateUrl: './emailer.component.html',
  styleUrl: './emailer.component.css'
})


export class EmailerComponent implements OnInit{
  isSupplierSelected: boolean;
  aaesApplnDatesId: any;
  showFYCreationMsg = false;
  fiscalYearCreationMsg =  'Fiscal Year Created Successfully.'
  fiscalYearFieldValidationMsg: string;
  showFYCreationErrorMsg: boolean;
  surveycheckboxChecked = false;
  @ViewChild('editor', { static: true }) editor: QuillEditorComponent;
  emailcontentid: any;
  sendEmailerContentBody: { isTest:boolean; subject: any; reportPeriod: any; emailBody: any; recipients: any; sendType: any; hasEscalate: boolean; testAddress: string; empId: number; emailcontentid: any; attachments: { fileName: string; mimeType: string; }[]; suppliers: any};
  recipients: any="";
  failureMsg: string;
  failureMessageAlert: boolean;
  employeeId: any;
  loginUserName: any;
  loginUserRole: string;
  displayUnauthorized: boolean;
  cancelAssumedUser: boolean;
  displayScreen: boolean;
  supplierCode: any;
  contentType = 'Content-Type';
  excelStyles: any[];
  disableExportEmailer = true;
  tooltipShowDelay = 100;
  bodyField = false;
  subjectField = false;
  sentContentValue: any;
  checkValidity: any;
  errorSubject: boolean;
  
  constructor(public http: HttpClient,public ngxSpinner:NgxSpinnerService,public formBuilder:FormBuilder, public lookup: LookupService,
    private readonly bservice: BusinessEntityService, private readonly router: Router, private readonly assumeRole: AssumedRoleStoreService, private readonly sortService: AgGridSortingService
    ){
      
      this.emailtext=`<br><div>Please click below to confirm receipt</div><br><a href=${this.serviceUrl}/supplierAcknowledgement?Rkey=<response_id>'>CLICK TO CONFIRM</a>`
      this.columnDefForEmailer = [
        {
          headerName: 'Supplier Code',
          field: 'suppliercodes',
          flex: 1,
          width: 60
        },
        {
          headerName: 'Supplier Name',
          field: 'suppliername',
          flex: 1,
          comparator: this.sortService.stringComparator,
          width: 90
        }, 
        {
          headerName: 'Supplier Email Recipients',
          field: 'contact',
          flex: 2,
          comparator: this.sortService.stringComparator,
          width: 110
        },
        {
          headerName: 'PSD Team',
          field: 'emails',
          flex: 5,
          comparator: this.sortService.stringComparator,
          width: 70
        },
        {
          headerName: 'Last Email Sent Date',
          field: 'latest_sent',
          flex: 1,
          width: 50,
          headerTooltip: 'Last Email Sent Date',
          cellRenderer: (params) => {
            return params.value? this.formatDateForGrid(params.value) : ''
          }
        },
      ]
      this.excelStyles = [
        {
          id: 'header',
          interior: {
            color: "#D3D3D3",
            pattern: "Solid"
          },
          alignment: {
            horizontal: "Center",
            vertical: "Center",
            wrapText: true
          },
          font: {
            bold: true
          },
          borders: {
            borderTop: {
              color: '#333333',
              lineStyle: 'Continuous',
              weight: 1
            },
            borderRight: {
              color: '#333333',
              lineStyle: 'Continuous',
              weight: 1
            },
            borderBottom: {
              color: '#333333',
              lineStyle: 'Continuous',
              weight: 1
            },
            borderLeft: {
              color: '#333333',
              lineStyle: 'Continuous',
              weight: 1
            }
          }
        },
        {
          id: 'cell',
          alignment: {
            horizontal: "Left",
            vertical: "Center",
            wrapText: true
          },
          borders: {
            borderTop: {
              color: '#333333',
              lineStyle: 'Continuous',
              weight: 1
            },
            borderRight: {
              color: '#333333',
              lineStyle: 'Continuous',
              weight: 1
            },
            borderBottom: {
              color: '#333333',
              lineStyle: 'Continuous',
              weight: 1
            },
            borderLeft: {
              color: '#333333',
              lineStyle: 'Continuous',
              weight: 1
            }
          }
        }
      ]
    }
    successMssg:any;
  successMessageAlert:any;
  files: FileData[] = [];
  isAnyFilesChosen: boolean;
  gridOptions: GridOptions;
  gridApi: GridApi;
  gridColumnApi: GridApi;
  domLayout='autoHeight';
  fiscalid:any;
  fiscalyear:any;
  contentid:any;
  filter:any="approved";
  lastsend:any;
  lastsendtest:any;
  lastresend:any;
  lastresendtest:any;
  emailForm:FormGroup;
  emailbody:any;
  setfydisable:any;
  saveEmailerContentBody:any;
  sendBody:any;
  appParentId:any=[];
  config = {  headers: {  "Content-Type": "" } };
  progress = 0; 
  message = '';
  serviceUrl:any;
  showModel:any;
  showTestModelContent: boolean;

  ngOnInit() {
    this.ngxSpinner.show();
    this.checkValidity = this.lookup.localStorageData.subscribe(async data => { 
      if(data?.includes('success')){
        this.displayUnauthorized = false;
        this.displayScreen = true;
        this.employeeId=this.bservice.loggedUserEmployeeId;
        this.loginUserName = this.bservice.loggedUserEmployeenameOriginal;
        const localStorageAssumeUser= JSON.parse(localStorage.getItem('userAssumed'));
        if(localStorageAssumeUser){
          this.assumeRole.assumeRoleByLocalStorage(localStorageAssumeUser)
        }else{
          this.assumeRole.assumeRoleByBService()
        }
        this.emailForm=this.formBuilder.group({
          fiscalYear:new FormControl(''),
          dueDate:new FormControl(''),
          reportPeriod:new FormControl(''),
          supplierFlag:new FormControl(''),
          emailBody:new FormControl(''),
          emailBodySurveyLink:new FormControl(''),
          excludeSurvey:new FormControl(''),
          test:new FormControl(''),
          escalateMgr:new FormControl(''),
          emailRadio:new FormControl(''),
          recipients:new FormControl(''),
          subject: new FormControl(''),
          testAddress: new FormControl('')
        })
        this.emailForm.controls['test'].setValue(true);
        this.emailForm.controls['escalateMgr'].setValue(false);
        this.emailForm.controls['emailRadio'].setValue('send');
        this.getreportPeriod();
        setTimeout(()=>{
          this.ngxSpinner.hide()
        },3000)
      } else if(data?.includes('failure')) {
        this.displayUnauthorized = true;
        this.displayScreen = false;
        const localStorageAssumeUser = localStorage.getItem('userAssumedData');
        if (localStorageAssumeUser==='noData') {
          this.cancelAssumedUser = true;
        }
        this.ngxSpinner.hide();
      }
    })
  }

  getreportPeriod(){
    const cachedData = this.lookup.getEmailerGridData();
    const currentReportPeriod = this.lookup.getEmailerLatestReportPeriod();
    this.lookup.getReportPeriod().subscribe((res) =>{
      this.reportData = res.body.response;
      this.emailForm.controls['reportPeriod'].setValue(this.reportData[0].unionreportperiodid);
      if(cachedData && (currentReportPeriod === this.reportData[0]?.unionreportperiodid)) {
        this.rowDataForEmailer = cachedData;
        this.getsavedEmail(this.reportData[0]?.unionreportperiodid)
        this.enableDisableExportGrid()
      } else {
        this.getSupplierEmailList(this.reportData[0]?.unionreportperiodid)
      }
    })
  }

  getSupplierEmailList(reportPeriod){
    this.lookup.getSuppliersForEmailer(reportPeriod,this.employeeId).subscribe((res) =>{
      this.rowDataForEmailer = res.body.response;
      this.lookup.setEmailerGridData(this.rowDataForEmailer, reportPeriod)
      this.getsavedEmail(reportPeriod)
      this.enableDisableExportGrid()
    })
  }

  enableDisableExportGrid() {
    if(this.rowDataForEmailer.length > 0) {
      this.disableExportEmailer = false;
    } else {
      this.disableExportEmailer = true;
    }
  }
  getsavedEmail(reportPeriod){
   this.lookup.getSavedEmail(reportPeriod,this.employeeId).subscribe((res) =>{
    const data = res.body.response;
    if(data !== "No Saved email found "){
      this.emailcontentid = data[0].emailcontentid
      this.emailForm.controls['reportPeriod'].setValue(data[0].reportperiodid);
      this.emailForm.controls['subject'].setValue(data[0].subject);
      this.emailForm.controls['emailBody'].setValue(data[0].body);
    }else{
      this.emailForm.controls['subject'].setValue('');
      this.emailForm.controls['emailBody'].setValue('');
      this.emailcontentid = "";
      this.sentContentValue = data[0]?.body?.response?.sentcontent
    }
   
    this.ngxSpinner.hide();
  })

  }

  saveEmail(){
    this.ngxSpinner.show();
    this.successMessageAlert = false;
    this.successMssg = "";
    this.failureMessageAlert = false;
    this.failureMsg = "";
    const attachments = [];
    for(const m of this.isAnyFiles){
      attachments.push({"fileName": m['fileName'],
      "mimeType": m['mimeType']})
    }
    if(this.emailcontentid && !this.sentContentValue){
      this.saveEmailerContentBody={
        "sentContent": false,
        "subject": this.emailForm.controls['subject'].value.trim(),
        "reportPeriod": this.emailForm.controls['reportPeriod'].value,
        "emailBody": this.emailForm.controls['emailBody'].value.trim(),
        "empId": this.employeeId,
        "emailcontentid": this.emailcontentid,
        "header": "Header for email content",
        "attachments": attachments
      }
      this.lookup.updateEmailerContent(this.saveEmailerContentBody).subscribe({
        next: (data)=>{
          if(data.statusCode === 200 && data.body?.emailcontentid) {
            this.successMssg="Emails content updated successfully."
            this.successMessageAlert=true;
            this.getsavedEmail(this.emailForm.controls['reportPeriod'].value);
          } else {
            this.failureMsg="Failed to update Email content";
            this.failureMessageAlert=true;
            this.ngxSpinner.hide()
          }
        },
        error: err =>{
          if(err){
            this.failureMsg="Failed to update Email content";
            this.failureMessageAlert=true;
          }
          this.ngxSpinner.hide();
        }
      })
      setTimeout(() => {
        this.closealert();
      }, 7000);
      
    }else{
      this.saveEmailerContentBody={
        "sentContent": false,
        "subject": this.emailForm.controls['subject'].value.trim(),
        "reportPeriod": this.emailForm.controls['reportPeriod'].value,
        "emailBody": this.emailForm.controls['emailBody'].value.trim(),
        "empId": this.employeeId,
        "header": "Header for email content",
        "attachments": attachments
      }
      this.lookup.saveEmailerContent(this.saveEmailerContentBody).subscribe({
        next: (data)=>{
          if(data.statusCode === 201 && data.body?.emailcontentid){
            this.successMssg="Emails content saved successfully."
            this.successMessageAlert=true;
            this.getsavedEmail(this.emailForm.controls['reportPeriod'].value);
          } else {
            this.failureMsg="Failed to save Email content";
            this.failureMessageAlert=true;
            this.ngxSpinner.hide()
          }
        }, 
        error: err=>{
          if(err){
            this.failureMsg="Failed to save Email content";
            this.failureMessageAlert=true;
          }
          this.ngxSpinner.hide();
        }
      })
      setTimeout(() => {
        this.closealert();
      }, 7000);
    }
    window.scrollTo(0,0);
    
  }
  emailtext:any;

  sendcheck() {
    this.recerr = false;
    this.bodyField = false;
    this.subjectField = false;

    const testChecked = this.emailForm.controls['test'].value;
    const testAddress = this.validateEmail(this.emailForm.controls['testAddress'].value);
    const emailBody = this.emailForm.controls['emailBody'].value;
    const subject = this.emailForm.controls['subject'].value;
    let hasError = false;
    if(testChecked && testAddress === "") {
      this.recerr = true;
      hasError = true;
      setTimeout(()=>{
        this.recerr = false;
      },5000);
    }
    if(!testChecked && testAddress === "") {
      this.recerr = false;
    }
    if (emailBody === "") {
      this.bodyField = true;
      hasError = true;
      setTimeout(()=>{
        this.bodyField = false;
      },5000);
    }
    if (subject === "") {
      this.subjectField = true;
      hasError = true;
      setTimeout(()=>{
        this.subjectField = false;
      },5000);
    }
    if (!hasError) {
      this.showTestModelContent = testChecked;
      this.showModel = true;
    }
  }

  validateEmail(value) {
    const emailRegex = /^[\w.-]+@[\w.-]+\.\w{2,4}(,\s*[\w.-]+@[\w.-]+\.\w{2,4})*$/
    const emailIdValue = value
      .split(',')
      .map(email => email.trim())
      .join(',');
    if(emailRegex.test(emailIdValue)) {
      return emailIdValue
    } else {
      return ''
    }
  }

  closeEmailerModel(){
    this.showModel=false;
  }

  closealert(){
    this.successMessageAlert = false;
    this.successMssg = "";
    this.failureMessageAlert = false;
    this.failureMsg = "";
  }
  
  sendEmail(){ 
    this.ngxSpinner.show();
    this.sendEmailerContentBody={
      "isTest": true,
      "subject": this.emailForm.controls['subject'].value.trim(),
      "reportPeriod": this.emailForm.controls['reportPeriod'].value,
      "emailBody": this.emailForm.controls['emailBody'].value.trim(),
      "recipients": this.recipients,
      "sendType": this.emailForm.controls['emailRadio'].value,
      "hasEscalate": this.emailForm.controls['escalateMgr'].value,
      "testAddress": this.emailForm.controls['testAddress'].value.trim(),
      "empId": this.employeeId,
      "emailcontentid": this.emailcontentid,
      "attachments": this.isAnyFiles,
      "suppliers": this.supplierCode,
    }

    if(!this.emailForm.controls['test'].value){
      this.sendEmailerContentBody.isTest = false;
      this.sendEmailerContentBody.testAddress = "";
    }

    const attachments = [];
    for(const m of this.isAnyFiles){
      attachments.push({"fileName": m['fileName'],
      "mimeType": m['mimeType']})
    }

    this.saveEmailerContentBody={
      "sentContent": true,
      "subject": this.emailForm.controls['subject'].value.trim(),
      "reportPeriod": this.emailForm.controls['reportPeriod'].value,
      "emailBody": this.emailForm.controls['emailBody'].value.trim(),
      "empId": this.employeeId,
      "attachments": attachments
    }
    this.lookup.saveEmailerContent(this.saveEmailerContentBody).subscribe((data)=>{
      this.sendEmailerContentBody.emailcontentid = data.body?.emailcontentid.emailcontentid;
      this.sendEmailerContentBody.attachments = data.body.filename;
      if(this.isAnyFiles.length>0){
        for (let i = 0; i < this.isAnyFiles.length; i++) {
          this.config.headers[this.contentType] = this.isAnyFiles[i].mimeType;
          const upload = this.http.put(data.body.attachments[i], this.isAnyFiles[i].file, this.config).toPromise(); //NOSONAR
          upload.then(_data => {
            if(this.isAnyFiles.length-1 === i) {
              this.sendEmails(this.sendEmailerContentBody);
            }
          }).catch(_err => {
          })
          if (data.type === HttpEventType.UploadProgress) {
            this.progress = Math.round(100 * data.loaded / data.total);
          } else if (data instanceof HttpResponse) {
            this.message = data.body.message;
          }
        }
      }else {
        this.sendEmails(this.sendEmailerContentBody);
      }
    })
  }
  
  sendEmails(sendEmailerContentBody){
    this.lookup.sendEmail(sendEmailerContentBody).subscribe({
      next: _event => {
        this.successMssg="Emails sent successfully."
        this.lookup.clearEmailerGridData();
        this.successMessageAlert=true;
        this.getSupplierEmailList(this.emailForm.controls['reportPeriod'].value);
        setTimeout(() => {
          this.successMessageAlert=false;
        }, 7000);
        this.ngxSpinner.hide();
      },
      error: err =>{
        if(err) {
          this.ngxSpinner.hide();
        }
      }
    })
    window.scroll(0,0);
  }

  checkboxChange(event){
    this.surveycheckboxChecked = event.target.checked;
    if(this.surveycheckboxChecked){
      this.emailForm.get('emailbodyforsurveylink')?.disable(); // disable
    }else{
      this.emailForm.get('emailbodyforsurveylink')?.enable();
    }   
    
  }

  defaultColDef={ 
    suppressNavigable: true,
    cellClass: 'no-border',
    suppressMovable: true,
    unSortIcon: true,
    floatingFilter: true,
    filter: 'agTextColumnFilter',
    wrapText: true,
    autoHeight: true,
    suppressHeaderMenuButton: true,
    suppressFloatingFilterButton: true,
    sortable: true
   };

   icons = {
    menu: ' ',
    filter: ' '
   }

   reportData:any = [];

  supplierFlagData = [];
  columnDefForEmailer = []
  
  rowDataForEmailer = []

  rowSelection = {
    mode: "multiRow",
  }

  onSelection() {
    const selectedRows = this.gridApi?.getSelectedRows();
    this.processSelectedData(selectedRows);
    this.isSupplierSelected = selectedRows?.length > 0;
  }

  processSelectedData(_selectedRows: any) {
    this.recipients="";
    for(let i=0;i<_selectedRows?.length;i++){
      if(i === 0){
        this.recipients = _selectedRows[i].emails;
        this.supplierCode=_selectedRows[i].suppliercodes
      }else{
        this.recipients = `${this.recipients},${_selectedRows[i].emails}`;
        this.supplierCode = `${this.supplierCode},${_selectedRows[i].suppliercodes}`;
      }
    }
  }
  filesizeerr:any;
  fileTypeErr = false;
  recerr:any;
  isAnyFiles:any=[];
  fileType = 'application/pdf';
  fileType2 = 'xlsx';
  fileType3 = 'xls'
  size= 0;
  onFileSelected(event: Event) {
    const input = event?.target as HTMLInputElement;
    if(input?.files && input?.files?.length > 0) { 
    const fileType =  this.fileType;
    checkMimeTypcv(input.files, function (mimetype: any) {  
      const lastDotIndex = input.files[0].name.lastIndexOf(".");
      const textAfterLastDot = input.files[0].name.substring(lastDotIndex + 1);
      this.size=0;
      for(const element of this.files){
        this.size+=Number(element.size);
      }
      this.size+=Number(input.files[0].size);
      if((mimetype === fileType || textAfterLastDot===this.fileType2 || textAfterLastDot===this.fileType3)&& this.size<=10485760) {
      this.filesizeerr=false;
      this.fileTypeErr = false;
      const file = input.files[0];
      this.files.push({
        file:input.files[0],
        size:file.size,
        name: file.name,
        isSelected: true,
        fileName: file.name,
        mimeType: mimetype
      }); 
      input.value = '';
      this.onCheckboxSelected();
      } 
      else if(this.size > 10485760){
        this.filesizeerr=true;
        this.fileTypeErr = false;
        setTimeout(()=>{
          this.filesizeerr=false
        },5000)
      } else {
        this.fileTypeErr = true;
        this.filesizeerr = false;
        setTimeout(()=>{
          this.fileTypeErr = false
        },5000)
      }
    }.bind(this));
    }
  }

  removeAttachment(index: number): void {
    this.files.splice(index, 1);
    this.isAnyFiles.splice(index, 1);
    this.onCheckboxSelected();
  }

  onCheckboxSelected(): void {
    this.isAnyFilesChosen = this.files.some((file) => this.isAnyFilesChosen = file.isSelected);

    if (this.isAnyFilesChosen) {
      this.files.forEach((file) => { 
        if (file.isSelected) {
          this.isAnyFiles.push(file)
        }
      });
    }
    this.isAnyFiles = this.isAnyFiles.filter((item, index) => {
      return this.isAnyFiles.indexOf(item) === index;
    });
    const isFiles=[];
    for(const element of this.isAnyFiles){
      if(element.isSelected===true){
        isFiles.push(element);
      }
    }
    this.isAnyFiles=isFiles;
  }

  validateSubject(event) {
    const inputElement = event.target as HTMLInputElement;
    const subjectRegex = /^[A-Za-z][A-Za-z0-9 ]*$/;
    const cleanSubject = inputElement.value
    if(subjectRegex.test(cleanSubject)) {
      if(cleanSubject.length < 2 || cleanSubject.length > 100) {
        this.errorSubject = true
      } else {
        this.errorSubject = false
      }
      return cleanSubject
    }  else {
      this.errorSubject = true
      return inputElement.value 
    }
  }

  onGridReady(params:any){
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi?.sizeColumnsToFit(); 
  }
  @HostListener("window:resize", ['$event'])
  onResize(_event) {

    if (this.gridApi != null) {

      this.gridApi?.sizeColumnsToFit();
      this.gridApi?.refreshCells();
    }

  }

  cancelNullGuidAssume() {
    this.displayUnauthorized = false;
    this.displayScreen = true;
    localStorage.clear();
    location.reload();
  }
  
  formatDateForGrid(value) {
    if (!value) {
      return '';
    } else {
      const isoformattedDate = value.replace(' ', 'T');
      const parsedDate = new Date(isoformattedDate);
      if (isNaN(parsedDate.getTime())) {
        return 'Invalid Date';
      } else {
        return new Intl.DateTimeFormat('en-US', {
          timeZone: 'UTC',
          year: 'numeric',
          month: 'numeric',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        }).format(parsedDate);
      }
    }
  }

  async exportGrid() {
    this.ngxSpinner.show()
    const allColumns = this.gridApi?.getAllDisplayedColumns();
    const columnsToExport = allColumns.slice(1).map(col => col.getColId()); //Ignoring the first checkbox column
    const date = new Date();
    const formattedDate = formatDate(date, 'M-d-y', 'en-US');
    const exportParams = {
      fileName: `Union Tracker Supplier Email List ${formattedDate}`,                                  
      columnKeys: columnsToExport,
      processCellCallback: (params) => {
        if((params.column.getColId() === 'latest_sent')) {
          return this.formatDateForGrid(params.value)
        } else {
          return params.value
        }
      }
    }
    await new Promise((resolve)=> {
      this.gridApi.exportDataAsExcel(exportParams)
      setTimeout(resolve, this.estimateExportTimeEmailer())
    })
    this.ngxSpinner.hide()
  }

  estimateExportTimeEmailer(): number {
    return this.gridApi ? this.calculateTimeEmailer() : 0;
  }

  calculateTimeEmailer() {
    const rows = this.gridApi?.getDisplayedRowCount()
    return Math.min(5000, rows * 10)
  }

  ngOnDestroy(){
    this.checkValidity?.unsubscribe();
  }
}
